<template>
  <section>
    <gs-header title="Quản lý hãng vận chuyển">
      <router-link :to="{ name: 'create-carrier' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="carrierTable" :table-name="carrierTable" data-source="carriers" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[carrierTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[carrierTable].current_page - 1) * dataPaginations[carrierTable].per_page) }}</small>
              </template>
            </el-table-column>

            <el-table-column label="HVC" width="300">
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{ scope.row.id }}</span></p>
                <p>
                  {{ scope.row.name }} ({{ scope.row.short_name }})
                </p>
                <p v-if="scope.row.is_cash">Giao hàng ứng tiền: <i class="fa text-green fa-check"></i></p>
              </template>
            </el-table-column>

            <el-table-column label="Phí">
              <template slot-scope="scope">
                <el-row :gutter="10">
                  <el-col :span="12" class="border-right">
                    <p>VAT: <span class="text-red pull-right">{{ scope.row.vat_fee | percent }}</span></p>
                    <p>Phí dịch vụ: <span class="text-red pull-right">{{ scope.row.service_fee | percent(2) }}</span>
                    </p>
                    <p>Phí bảo hiểm: <span class="text-red pull-right">{{ scope.row.insurrance_fee | percent(2)
                        }}</span>
                    </p>
                  </el-col>
                  <el-col :span="12">
                    <p>Phí xăng dầu: <span class="text-red pull-right">{{ scope.row.oil_fee | percent }}</span></p>
                    <p>Hệ số vùng xa: <span class="text-red pull-right">{{ scope.row.remote_area_fee | percent }}</span>
                    </p>
                    <p>Cân nặng quy đổi: <span class="text-orange pull-right">{{ scope.row.weight_rate | gam }}</span>
                    </p>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                    <a @click.prevent="detailCarrier(scope.row)"
                      class="text-blue padding-all display-inline-block cursor-pointer"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-carrier', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteCarrier(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="'Chi tiết hãng vận chuyển: ' + carrier.name" :visible.sync="detailModal">
        <el-row :gutter="10">
          <el-col :span="6">
            <img :src="carrier.logo_path" width="100" height="100" :alt="carrier.name"
              onerror="this.src='https://placeholdit.imgix.net/~text?txtsize=19&txt=carrier&w=150&h=150'">
            <h3 class="text-bold text-blue">{{ carrier.name }}</h3>
            <el-tooltip placement="top" content="Tên viết tắt" class="display-inline">
              <span class="text-green">{{ carrier.short_name }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <table class="width-100">
              <thead>
                <tr>
                  <td class="text-bold">Loại phí</td>
                  <td class="text-bold">Giá trị</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span>VAT</span></td>
                  <td><span class="text-red">{{ carrier.vat_fee | percent }}</span></td>
                </tr>
                <tr>
                  <td><span>Phí dịch vụ</span></td>
                  <td><span class="text-red">{{ carrier.service_fee | percent(2) }}</span></td>
                </tr>
                <tr>
                  <td><span>Phí bảo hiểm</span></td>
                  <td><span class="text-red">{{ carrier.insurrance_fee | percent(2) }}</span></td>
                </tr>
                <tr>
                  <td><span>Phí xăng dầu</span></td>
                  <td><span class="text-red">{{ carrier.oil_fee | percent }}</span></td>
                </tr>
                <tr>
                  <td><span>Hệ số vùng xa</span></td>
                  <td><span class="text-red">{{ carrier.remote_area_fee | percent }}</span></td>
                </tr>
                <tr>
                  <td><span>Cân nặng quy đổi</span></td>
                  <td><span class="text-orange">{{ carrier.weight_rate | gam }}</span></td>
                </tr>
                <tr v-if="carrier.is_cash">
                  <td><span>Giao hàng ứng tiền</span></td>
                  <td><i class="fa fa-check text-green"></i></td>
                </tr>
              </tbody>
            </table>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import ls from 'local-storage'
import { debounce } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { deleteCarrier, restoreCarrier } from 'src/api/carrier'
export default {
  name: 'Carrier',
  data() {
    return {
      carrierTable: 'carriers',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      detailModal: false
    }
  },
  computed: {
    ...mapGetters('carrier', ['carrier'])
  },
  methods: {
    ...mapActions('carrier', ['setCarrier']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.carrierTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.carrierTable)
      }
    }, 300),
    removeFilter() {
      this.reloadGsTable(this.carrierTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    detailCarrier(carrier) {
      this.setCarrier(carrier)
      this.detailModal = true
    },
    deleteCarrier(carrier) {
      this.setCarrier(carrier)
      this.$confirm(`Bạn chắc chắn muốn xóa hãng vận chuyển ${this.carrier.name}`, 'Xóa hãng vận chuyển', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delCarrier()
      }).catch(() => {

      })
    },
    delCarrier() {
      deleteCarrier(this.carrier.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa hãng vận chuyển thành công'
          })
          this.reloadGsTable(this.carrierTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa hãng vận chuyển thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(carrier) {
      this.setCarrier(carrier)
      this.$confirm(`Bạn chắc chắn muốn khôi phục hãng vận chuyển ${this.carrier.name}`, 'Khôi phục hãng vận chuyển', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resCarrier()
      }).catch(() => {

      })
    },
    resCarrier() {
      restoreCarrier(this.carrier.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục hãng vận chuyển thành công'
          })
          this.reloadGsTable(this.carrierTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục hãng vận chuyển thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.carrierTable]) {
      this.filters = ls.get('filters')[this.carrierTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.carrierTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['carriers']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}
</style>



// WEBPACK FOOTER //
// Carrier.vue?ac23df44